import React, { useEffect, useState } from 'react';
import { Flex, Spin } from "antd";
import styles from './company-emails.module.scss'
// @ts-ignore
import { ReactComponent as LogoIcon } from '../../../../assets/images/logo/logo.svg'
import VerificationRequestModal from "../components/VerificationRequestModal/VerificationRequestModal";
import { useSearchCompanyMutation } from "../../../../redux/API/companySlice";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import IsAlreadyRegisteredModal from "../components/IsAlreadyRegisteredModal/IsAlreadyRegisteredModal";
import VerificationRequestToOwnerModal
  from "../components/VerificationRequestToOwnerModal/VerificationRequestToOwnerModal";
import { useDispatch } from "react-redux";
import { addSignUpData } from "../../../../redux/businessSlice"
import { ReactComponent as CameraSvg } from '../../../../assets/images/global-icons/camera_ic.svg';

interface Company {
  id: string;
  companyName: string;
  companyEmail: string;
  companyAddress: string;
  imageUrl: string;
  placeId: string;
  link: string;
}

const CompanyEmails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false)
  const [companyName, setCompanyName] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [companyData, setCompanyData] = useState<Company>({
    id: '',
    companyName: '',
    placeId: '',
    companyAddress: '',
    companyEmail: '',
    imageUrl: '',
    link: ''
  });
  const [searchCompany, { data, isLoading }] = useSearchCompanyMutation();

  console.log(data)

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { placeId, userCompanyName } = location.state || {};

  const company = data?.data?.company;
  const emails = data?.data?.emails?.slice(0, 4);

  useEffect(() => {
    if (placeId) {
      searchCompany({
        placeId: placeId
      })
    }
  }, [placeId]);

  const handleCompanyClick = async (email: any) => {
    const isExist = company?.id !== null;

    if (company) {
      setCompanyData({
        id: company.id ?? '',
        companyName: company.companyName,
        companyEmail: email.companyEmail,
        placeId: company.placeId,
        companyAddress: company.address,
        link: company.link ?? '',
        imageUrl: company.picture ?? ''
      });

      dispatch(
        addSignUpData({
          company: {
            id: company.id ?? '',
            companyName: company.companyName,
            email: email.companyEmail,
            placeId: company.placeId,
            address: company.address,
            website: company.link,
            imageUrl: company.picture ?? ''
          }
        })
      );
    }

    if (isExist) {
      setIsModalOpen(true);
      setCompanyName(company?.companyName ?? '');
      setCompanyEmail(email.companyEmail);
    } else {
      navigate('../business/email');
    }
  };


  return (
    <Flex className={styles.CompanyEmails__wrapper} justify={"center"} align={"start"}>
      <Flex className={styles.CompanyEmails} vertical>
        <Flex className={styles.CompanyEmails__header} vertical justify={"center"} align={"center"} gap={'32px'}>
          <LogoIcon />
          <Flex vertical gap={'16px'}>
            <h1>Create New Account</h1>
            <Flex className={styles.CompanyEmails__header__subtitle} vertical>
              <span>Here's what we found</span>
              <p>
                <Link
                  to={'../business/contact-us'}
                  state={{
                    placeId,
                    userCompanyName,
                    address: company?.address,
                    from: 'email'
                  }}
                >
                  Can't find your email?
                </Link>
              </p>
            </Flex>
          </Flex>
        </Flex>
        <Flex className={styles.CompanyEmails__result}>
          <IsAlreadyRegisteredModal
            visible={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            company={companyData}
            setIsVerificationRequestToOwnerOpen={setIsVerificationModalOpen}
          />
          <VerificationRequestToOwnerModal visible={isVerificationModalOpen} onClose={() => setIsVerificationModalOpen(false)} companyEmail={companyEmail} />
          <>
            {isLoading ? <Spin fullscreen /> : (
              emails?.length ? (
                <Flex vertical className={styles.CompanyEmails__result__body}>
                  {emails.map((email: any, index: number) => (
                    <Flex
                      key={index}
                      className={styles.CompanyEmails__result__item}
                      align={"center"}
                      gap={'6px'}
                      onClick={() => handleCompanyClick(email)}
                    >
                      {company?.picture ? (
                        <img
                          className={styles.CompanyEmails__result__item__image}
                          src={company.picture}
                          alt="company"
                        />
                      ) : (
                        <div className={styles.CompanyEmails__result__item__CameraSvg}>
                          <CameraSvg />
                        </div>
                      )}

                      <Flex className={styles.CompanyEmails__result__item__content} vertical gap={'6px'}>
                        <span>{email.emailName || email.companyEmail}</span>
                        <p>{email.companyEmail}</p>
                      </Flex>
                    </Flex>
                  ))}
                </Flex>
              ) : null
            )}
          </>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CompanyEmails;